import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-preview-email-template',
  imports: [SharedModule],
  templateUrl: './preview-email-template.component.html',
  styleUrl: './preview-email-template.component.scss'
})
export class PreviewEmailTemplateComponent {
  sanitizedData: SafeHtml = '';  // SafeHtml for srcdoc binding
  @Input() type: string = 'email';
  @Input() showHeader: boolean = true;
  @Input() documents: any[] = [];

  @Output() closeDialog = new EventEmitter();

  constructor(private sanitizer: DomSanitizer) { }

  @Input() processedData: any;

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  ngOnInit() {
    this.sanitizedData = this.processedData;
  }

  getFileType(fileName: string): string {
    const ext = fileName.split('.').pop()?.toLowerCase();
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext || '')) return 'image';
    if (['mp4', 'avi', 'mov', 'wmv'].includes(ext || '')) return 'video';
    if (['pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt'].includes(ext || '')) return 'document';
    return 'document';
  }

  getFileTypeFromUrl(url: string): string {
    const fileName = url.split('/').pop() || '';
    return this.getFileType(fileName);
  }

  getFileNameFromUrl(url: string): string {
    return url.split('/').pop() || 'File';
  }

  getFileIcon(type: string): string {
    switch(type) {
      case 'image': return 'pi-image';
      case 'video': return 'pi-video';
      case 'document': return 'pi-file';
      default: return 'pi-file';
    }
  }
}
